function Content4() {
  return (
    <div style={{ maxWidth: "850px" }}>
      <div className="mobileImg">
        <img
          style={{ maxWidth: "850px", width: "100%" }}
          src="../../../images/png/news-4.png"
          alt="Img4"
        />
      </div>
      <div style={{ fontSize: "14px" }}>
        Foto: Kehra pulp and paper mill in Estonia / Vikipeedia
      </div>
      <h1 className="title">
        Horizon Tselluloosi ja Paberi kogemus: automatiseeritud kütusehange muudab töö kiiremaks ja lihtsamaks
      </h1>
      <div className="content">
        <div>27.07.2026</div>
        <div>
          Horizoni Tselluloosi ja Paberi igapäevases tegevuses ja tööstusprotsesside toimimises mängib kütus
          kriitilist rolli. <b>Kuna iga tarneviivitus võib otseselt mõjutada tootmise sujuvust, on tarnekindlus
            ettevõtte jaoks äärmiselt tähtis.</b> Ostuosakonna esindaja Maia-Maria sõnul oli enne Turgoili platvormi
          kasutuselevõttu kütuse hankimine korraldatud peamiselt käsitsi, mis tähendas pidevat päringute tegemist,
          hinnavõrdlusi ja suhtlust erinevate tarnijatega.
        </div>
        <div className="subTitle">Käsitsitöö asendus kiiruse ja täpsusega</div>
        <div>
          Otsus hakata tellimusi tegema läbi Turgoili sündis vajadusest protsesse kaasajastada.
          „Peamised põhjused, miks otsustasime Turgoili kaudu tellimusi teha, olid mugavus, kiirus ja täpsus.
          Võimalus kogu protsessi lihtsamalt hallata oli meie jaoks suur väärtus,“ kirjeldab Maia-Maria ülemineku tagamaid.
        </div>
        <div className="subTitle quote">
          «Protsess on lihtne, kiire ja läbipaistev ning kogu tellimise loogika on kasutajasõbralik.»
        </div>
        <div>
          Senine kogemus platvormiga ongi ettevõtte hinnangul olnud väga hea.
          <b> Võrreldes varasema manuaalse töökorraldusega on märgatud märkimisväärset
            ajasäästu ja hangete lihtsustumist.</b> Maia-Maria lisab, et kiirus, täpsus ja
          mugavus ongi need peamised eelised, mis vana süsteemiga võrreldes kohe silma paistavad.
        </div>
        <div className="subTitle">Automatiseerimine on kütusehanke tulevik</div>
        <div>
          Laiemas vaates näeb Horizon automatiseeritud lahendustes kütuseturule ainsat loogilist suunda.
          <b> Digitaalne hange aitab säästa aega, vähendada käsitöö mahtu ning muuta kogu protsessi efektiivsemaks
            ja paremini hallatavaks.</b> „Usume, et kütuse hankimine liigub tulevikus kindlasti järjest rohkem automatiseerimise
          suunas. Ettevõtted hindavad aina enam lahendusi, mis muudavad protsessid kiiremaks, täpsemaks ja mugavamaks,“ märgib Maia-Maria.
        </div>
        <div className="subTitle">Professionaalne suhtlus ja paindlik lähenemine</div>
        <div>
          Lisaks mugavale e-keskkonnale soovib Horizoni Kehra tehas eraldi välja tuua ka positiivse kogemuse suhtluses
          Turgoili meeskonnaga. Eriti hinnatakse professionaalset ja kliendikeskset koostööd Tõnuga, kes aitas leida lahenduse
          spetsiifilisele väljakutsele. „Oleme temaga suhelnud ka spetsiaalse kütuse osas, mida Turgoili platvormil ei ole pakkumisel.
          Tõnu uuris võimalusi oma tarnijate seas ja leidis lahenduse. Väga professionaalne,“ tunnustab Maia-Maria.
          Just selline paindlikkus ja valmidus kliendile vastu tulla loob ettevõtte hinnangul usaldust ning aitab
          kaasa sujuvale pikaajalisele koostööle.
        </div>
      </div>
    </div>
  );
}

export default Content4;
